import React, { useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import Navbar from './components/layout/Navbar';
import { themes } from './components/ThemeSelector';
import { selectTheme } from './store/themeSlice';
import { fetchAllPokemon } from './store/pokemonSlice';
import SocialSupport from './components/SocialSupport';

import Home from './pages/Home';
import PokemonDatabase from './pages/PokemonDatabase';
import PokemonDetail from './pages/PokemonDetail';
import Competitive from './pages/Competitive';
import TypeChart from './pages/TypeChart';
import Abilities from './pages/Abilities';
import AbilityDetail from './pages/AbilityDetail';
import Moves from './pages/Moves';
import MoveDetail from './pages/MoveDetail';
import Items from './pages/Items';
import ItemDetail from './pages/ItemDetail';
import './App.css';

function App() {
  const dispatch = useDispatch();
  const currentTheme = useSelector(selectTheme);
  const location = useLocation();

  useEffect(() => {
    // Reset scroll position on route change
    window.scrollTo(0, 0);
  }, [location.pathname, location.key]);

  useEffect(() => {
    // Fetch Pokemon data when app starts
    dispatch(fetchAllPokemon());
  }, [dispatch]);

  useEffect(() => {
    // Apply theme colors to CSS variables
    const theme = themes[currentTheme].colors;
    document.documentElement.style.setProperty('--primary-color', theme.primary);
    document.documentElement.style.setProperty('--secondary-color', theme.secondary);
    document.documentElement.style.setProperty('--accent-color', theme.accent);
  }, [currentTheme]);

  return (
    <div className="App">
      <Navbar currentTheme={currentTheme} />
      <main className="container">
        <Routes key={location.pathname}>
          <Route path="/" element={<Home currentTheme={currentTheme} />} />
          <Route path="/database" element={<PokemonDatabase />} />
          <Route path="/pokemon/:id" element={<PokemonDetail />} />
          <Route path="/competitive/*" element={<Competitive />} />
          <Route path="/abilities" element={<Abilities />} />
          <Route path="/abilities/:name" element={<AbilityDetail />} />
          <Route path="/moves" element={<Moves />} />
          <Route path="/moves/:name" element={<MoveDetail />} />
          <Route path="/items" element={<Items />} />
          <Route path="/items/:name" element={<ItemDetail />} />
          <Route path="/types" element={<TypeChart />} />
        </Routes>
      </main>
      <SocialSupport />
    </div>
  );
}

export default App; 